import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'frodo-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() cardTitle: string;
  @Input() cardBackgroundColor: string;
  @Input() cardIcon: string;
  @Input() cardTitleColor: string;
  @Output() onClick = new EventEmitter<any>();

  onClickPressed() {
    this.onClick.emit();
  }
}
